<app-dialog-heading [heading]="'Member Lookup'"></app-dialog-heading>
<div *ngIf="isBusyCounter > 0" class="center-container">
  <mat-spinner></mat-spinner>
</div>
<div class="header-spacer">
  <mat-grid-list cols="1" rowHeight="75px">
    <mat-grid-tile>
      <div class="radio-group">
        <mat-radio-group (change)="onCardOrIdNumberRadioOptionValueChanged($event)">
          <mat-radio-button [checked]="isSearchByCardNumberSelected" class="m-b-5" [value]="searchType.CardNumber">
            {{searchType.CardNumber}}
          </mat-radio-button>
          <mat-radio-button class="m-b-5" [value]="searchType.IdNumber">
            {{searchType.IdNumber}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <mat-form-field class="w-70">
        <mat-label>Search Member by {{isSearchByCardNumberSelected ? searchType.CardNumber : searchType.IdNumber}}</mat-label>
        <input matInput type="text" (input)="onInputChangedSearchMembers($event)">
      </mat-form-field>
      <mat-icon [matTooltip]="'Search by member card number or ID number'" class="info-icon">
        help_outline
      </mat-icon>
    </mat-grid-tile>
  </mat-grid-list>

  <div *ngIf="insuredPerson; else elseBlock" class="flex justify-center">
    <mat-card>
      <mat-card-content>
        <div class="property-grid">
          <div *ngFor="let property of insuredPersonDisplayProperties" class="p-0-5">
            <div class="property-name">{{property.name}}</div>
            <div>{{property.value}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <ng-template #elseBlock>
    <div class="center text-container">
      <mat-icon [ngStyle]="maticon === 'warning' ? {color: 'orange'} : {color: 'red'}"
        class="mr-0-5">{{maticon}}</mat-icon>
      {{message}}
    </div>
  </ng-template>
</div>
<mat-dialog-actions align="center" class="dialog-button-container flex">
  <button class="dialog-button" mat-raised-button (click)="onClickOkay()" color="primary">Okay</button>
</mat-dialog-actions>